import { LogsService } from '@gtpl/shared-services/user-logs';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { HolidaysCalendarAdapter } from './dto/holidays-calendar.adapter';
import { HolidaysCalendar } from './holidays-calendar.entity';
import { HolidaysCalenderController } from './holidays-calender.controller';
import { HolidaysCalenderService } from './holidays-calender.service';
import { HolidaysCalendarLog } from './holidays-calendar-log.entity';

@Module({
  imports: [
    
    TypeOrmModule.forFeature([HolidaysCalendar,HolidaysCalendarLog]),
    // forwardRef(() => ClusterModule),
  ],
  controllers: [HolidaysCalenderController],
  providers: [HolidaysCalenderService,HolidaysCalendarAdapter,ApplicationExceptionHandler,LogsService],
  exports: [HolidaysCalenderService]
})
export class HolidaysCalenderModule {}
